module.exports = __webpack_public_path__ + "img/chatgpt-ico.2517a3dd.svg";